import {Component, input} from '@angular/core';
import {AnimalSvgComponent} from "src/app/presentation/common/icons/animal-svg/animal-svg.component";
import {
  LoadingPlaceholderComponent
} from "src/app/presentation/common/loading-placeholder/loading-placeholder.component";
import {Animal, AnimalType} from "src/app/infrastructure/moovement-api/models/asset";
import {RoutingService} from 'src/app/infrastructure/routing/routing.service';

@Component({
  selector: 'app-base-animals-button',
  imports: [
    AnimalSvgComponent,
    LoadingPlaceholderComponent
  ],
  templateUrl: './base-animals-button.component.html',
  styleUrl: './base-animals-button.component.css'
})
export class BaseAnimalsButtonComponent {

  loading = input.required<boolean>();
  title = input.required<string>();
  url = input.required<string>();

  unknown = input.required<Animal[]>();
  cows = input.required<Animal[]>();
  bulls = input.required<Animal[]>();
  steers = input.required<Animal[]>();
  calves = input.required<Animal[]>();

  AnimalType = AnimalType;

  constructor(
    protected routingService: RoutingService
  ) {}
}
